<template>
    <transition :name="callBottomBar">
        <div class="bottom-bar" v-if="callBottomBar" @click="actionSeekHelp('Fixed')">
            <span>没找到想要的内容？</span>
            <button><i></i>求助</button>
        </div>
    </transition>
</template>

<script>
    import commonMixin from '@/utils/commonMixin'
    export default {
        name: "bottomBar",
        mixins: [ commonMixin ],
        data() {
            return {}
        },
        computed: {
            callBottomBar() {
                return this.$store.getters.bottomBar
            },
            searchContent() {
                return sessionStorage.nio_question
            }
        }
    }
</script>

<style lang="scss" scoped type="text/scss">

    .bottom-bar {
        position: fixed;
        height: j(150);
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 j(50);
        background-color: #fff;
        box-shadow: 0px j(-5) j(30) 0px rgba(4, 11, 41, 0.04);
        span {
            font-size: j(28);
            color: #363C54;
        }

        button {
            min-width: j(208);
            font-size: j(32);
            box-sizing: border-box;
            outline: none;
            border: none;
            background-color: #00bebe;
            border-radius: j(45);
            height: j(90);
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            i {
                display: inline-block;
                width: j(40);
                height: j(40);
                background: url("/static/images/icon/question_icon.png") no-repeat;
                background-size: contain;
                margin-right: j(5);
            }
        }
    }


    @import "./animation.scss";
</style>



// WEBPACK FOOTER //
// src/views/search/bottomBar.vue